// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TOSS App Styles — formerly UPSI */
.upsi-sidebar {
  width: 248px;
  min-height: 100vh;
  border-right: 1px solid #EEF3EE;
  background: #FFFFFF;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
}

.upsi-main {
  margin-left: 248px;
  min-height: 100vh;
  background: #F8FAF8;
}

.upsi-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 20px 9px 22px;
  margin: 1px 10px;
  border-radius: 10px;
  color: #617364;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.005em;
  transition: all 0.18s ease;
  text-decoration: none;
}

.upsi-nav-item:hover {
  background: #F4F8F4;
  color: #1B291D;
}

.upsi-nav-item.active {
  background: linear-gradient(90deg, #F0F7F1 0%, #F4F8F4 100%);
  color: #1B291D;
  font-weight: 600;
  box-shadow: inset 2px 0 0 #43A047;
}

.upsi-score-ring {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: conic-gradient(
    #43A047 calc(var(--score) * 36deg),
    #E0E6E1 calc(var(--score) * 36deg)
  );
  position: relative;
}

.upsi-score-ring::after {
  content: '';
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  position: absolute;
}

.upsi-score-ring .score-value {
  position: relative;
  z-index: 1;
  font-size: 2.5rem;
  font-weight: 300;
  color: #1B291D;
  font-family: 'Work Sans', sans-serif;
}

.wizard-step-indicator {
  display: flex;
  align-items: center;
  gap: 0;
}

.wizard-step {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #617364;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-step.active {
  color: #43A047;
  border-bottom-color: #43A047;
}

.wizard-step.completed {
  color: #388E3C;
}

.wizard-step .step-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #E0E6E1;
  color: #617364;
}

.wizard-step.active .step-num {
  background: #43A047;
  color: white;
}

.wizard-step.completed .step-num {
  background: #388E3C;
  color: white;
}

@media (max-width: 768px) {
  .upsi-sidebar {
    display: none;
  }
  .upsi-main {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;GAGC;EACD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* TOSS App Styles — formerly UPSI */\n.upsi-sidebar {\n  width: 248px;\n  min-height: 100vh;\n  border-right: 1px solid #EEF3EE;\n  background: #FFFFFF;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n}\n\n.upsi-main {\n  margin-left: 248px;\n  min-height: 100vh;\n  background: #F8FAF8;\n}\n\n.upsi-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 20px 9px 22px;\n  margin: 1px 10px;\n  border-radius: 10px;\n  color: #617364;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n  transition: all 0.18s ease;\n  text-decoration: none;\n}\n\n.upsi-nav-item:hover {\n  background: #F4F8F4;\n  color: #1B291D;\n}\n\n.upsi-nav-item.active {\n  background: linear-gradient(90deg, #F0F7F1 0%, #F4F8F4 100%);\n  color: #1B291D;\n  font-weight: 600;\n  box-shadow: inset 2px 0 0 #43A047;\n}\n\n.upsi-score-ring {\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: conic-gradient(\n    #43A047 calc(var(--score) * 36deg),\n    #E0E6E1 calc(var(--score) * 36deg)\n  );\n  position: relative;\n}\n\n.upsi-score-ring::after {\n  content: '';\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  background: white;\n  position: absolute;\n}\n\n.upsi-score-ring .score-value {\n  position: relative;\n  z-index: 1;\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: #1B291D;\n  font-family: 'Work Sans', sans-serif;\n}\n\n.wizard-step-indicator {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.wizard-step {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #617364;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-step.active {\n  color: #43A047;\n  border-bottom-color: #43A047;\n}\n\n.wizard-step.completed {\n  color: #388E3C;\n}\n\n.wizard-step .step-num {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  background: #E0E6E1;\n  color: #617364;\n}\n\n.wizard-step.active .step-num {\n  background: #43A047;\n  color: white;\n}\n\n.wizard-step.completed .step-num {\n  background: #388E3C;\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .upsi-sidebar {\n    display: none;\n  }\n  .upsi-main {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
